import AudioActionRow from '../AudioActionRow/AudioActionRow';

const AudioLibrarySection = ({
  sectionCardClass,
  isCompactLayout,
  audioList,
  canEditDelete,
  selectedAudios,
  onAudioSelectToggle,
  toEdit,
  editName,
  setEditName,
  onEdit,
  onResolveEdit,
  onCancelEdit,
  setToDelete,
  updateAudioList,
}) => {
  return (
    <div className={sectionCardClass}>
      <div className="d-flex align-items-center justify-content-between bg-primary px-3 py-2 border-bottom border-secondary">
        <span className="fw-semibold">Select from pre-existing files</span>
      </div>

      <div
        className={`min-h-0 ${
          isCompactLayout
            ? 'overflow-y-auto overflow-x-hidden'
            : 'd-flex flex-column flex-grow-1 overflow-hidden'
        }`}
        style={isCompactLayout ? { maxHeight: '16rem' } : undefined}
      >
        {audioList.length === 0 ? (
          <p className="text-muted text-center py-3 mb-0">No files uploaded yet.</p>
        ) : (
          <div className="overflow-y-auto flex-grow-1 min-h-0">
            {audioList.map((audio, index) => (
              <AudioActionRow
                key={audio.id ?? index}
                audio={audio}
                index={index}
                compact={isCompactLayout}
                checked={selectedAudios.includes(audio.id)}
                onToggle={(e) => onAudioSelectToggle(e, audio.id)}
                toEdit={toEdit}
                editName={editName}
                onEditNameChange={setEditName}
                onEdit={onEdit}
                onResolveEdit={onResolveEdit}
                onCancelEdit={onCancelEdit}
                onDelete={setToDelete}
                canEditDelete={canEditDelete}
                updateAudioList={updateAudioList}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AudioLibrarySection;
